/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const saveBookmarkV1RequestSchema = z.object({
  saved: z.boolean(),
});

export type ISaveBookmarkV1Body = z.infer<typeof saveBookmarkV1RequestSchema>;

export interface ISaveBookmarkV1Request extends ISaveBookmarkV1Body {
  challengeId: number;
}
